/**
 * This class contains all the information about the concrete Google product,
 * either subscription or in-app. In case of a subscription also determines concrete base plan.
 */
export class ProductStoreDetails {
    constructor(basePlanId, purchaseOptionId, productId, name, title, description, subscriptionOfferDetails, defaultSubscriptionOfferDetails, basePlanSubscriptionOfferDetails, inAppOfferDetails, hasTrialOffer, hasIntroOffer, hasTrialOrIntroOffer, productType, isInApp, isSubscription, isPrepaid, isInstallment) {
        this.basePlanId = basePlanId;
        this.purchaseOptionId = purchaseOptionId;
        this.productId = productId;
        this.name = name;
        this.title = title;
        this.description = description;
        this.subscriptionOfferDetails = subscriptionOfferDetails;
        this.defaultSubscriptionOfferDetails = defaultSubscriptionOfferDetails;
        this.basePlanSubscriptionOfferDetails = basePlanSubscriptionOfferDetails;
        this.inAppOfferDetails = inAppOfferDetails;
        this.hasTrialOffer = hasTrialOffer;
        this.hasIntroOffer = hasIntroOffer;
        this.hasTrialOrIntroOffer = hasTrialOrIntroOffer;
        this.productType = productType;
        this.isInApp = isInApp;
        this.isSubscription = isSubscription;
        this.isPrepaid = isPrepaid;
        this.isInstallment = isInstallment;
    }
}
//# sourceMappingURL=ProductStoreDetails.js.map